// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card__bank-address[data-v-5c1a3f38] {
  margin-top: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/application/bank_details/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACI;EACI,mBAAA;ACAR","sourcesContent":["\n    .card__bank-address {\n        margin-top: 1.25rem;\n    }\n",".card__bank-address {\n  margin-top: 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
